import type { ReservationStatus } from '@shared/types/reservations';
import { Status, StatusPill } from '../statusPill/StatusPill';

export interface ReservationGuestSheetStatusesProps {
  isHostBooked?: boolean;
  isStranded?: boolean;
  reservationStatus?: ReservationStatus;
}

export const ReservationGuestSheetStatuses = ({
  isHostBooked = false,
  isStranded = false,
  reservationStatus,
}: ReservationGuestSheetStatusesProps) => {
  const hasStatus =
    reservationStatus === 'canceled' ||
    reservationStatus === 'noShow' ||
    isHostBooked ||
    isStranded;

  return hasStatus ? (
    <>
      {reservationStatus === 'canceled' && (
        <StatusPill status={Status.Canceled} />
      )}
      {isHostBooked && <StatusPill status={Status.HostBooked} />}
      {isStranded && <StatusPill status={Status.Stranded} />}
      {reservationStatus === 'noShow' && <StatusPill status={Status.NoShow} />}
    </>
  ) : null;
};
